module.exports = __webpack_public_path__ + "img/Ramunas_G.f42efe22.jpg";